import { render, staticRenderFns } from "./TotalSales.vue?vue&type=template&id=8f919414&scoped=true&"
import script from "./TotalSales.vue?vue&type=script&lang=js&"
export * from "./TotalSales.vue?vue&type=script&lang=js&"
import style0 from "./TotalSales.vue?vue&type=style&index=0&id=8f919414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f919414",
  null
  
)

export default component.exports